import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter  } from "react-router-dom";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import { loginUser1 } from "../../actions/authActions";
import classnames from "classnames";
import {toast,Toaster } from 'react-hot-toast';
import * as myConstList from '../../BaseUrl';
import $ from 'jquery';
import axios from 'axios';
import { isMobile, isDesktop, isAndroid, isIOS, browserName, browserVersion, osName, osVersion } from "react-device-detect";
const callBackBaseUrl = myConstList.callBackBaseUrl;
const toastStyles = {
    style: {
      borderRadius: '10px',
      background: '#fff',
      color: '#000',
    },
  }
class Login extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            email: "",
            password: "",
            type:"password",
            errors: {
           },
         };
    }
	
	getUserIp = ()=> {
        
        axios.get('https://geolocation-db.com/json/').then((response) => {
			let data = response.data;
			this.setState({ip:data.IPv4 ? data.IPv4 : ""
						});
		}).catch((error) => {
			console.log(error);
		});
	}


	DeviceName = () => {
		if (isMobile) { 
			this.setState({ device: "Mobile" });
		}
		else if (isAndroid) {
			this.setState({ device: "Android" });
		}
		else if (isIOS) {
			this.setState({ device: "IOS" });
		}
		else if (isDesktop) {
			this.setState({ device: "Desktop" })
		}
	}

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
                       
            this.setState({
                errors: {},
                email:"",
                password:''
            }); 
        }else{     
            // this.setState({errors:{email:nextProps.auth.reg.data.email,password:nextProps.auth.reg.data.password,password2:nextProps.auth.reg.data.password2}});
        }

        if (nextProps.errors) {
            // window.location = callBackBaseUrl+"/#/login-page/?callBack="+window.location.origin;
            if(nextProps.errors.message !="" && nextProps.errors.message != undefined){
                setTimeout(function() {
                    toast.error( nextProps.errors.message,toastStyles);
                    nextProps.errors.message = "";
                }, 500);                
            }else if(nextProps.errors.password1 !="" && nextProps.errors.password1 != undefined){
                toast.error(nextProps.errors.password1,toastStyles);
            }            
            this.setState({
                errors: nextProps.errors
             });         
        }        
    }
    componentDidMount() {
		this.getUserIp();
		this.DeviceName();
        const params = new Proxy(new URLSearchParams(this.props.history.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });
        let ssoToken = params.ssoToken;
        let uid = params.uid;  
        let source = "";
        let theme = "";
        if(params.source){
            source = params.source; 
        }
        if(params.source){
            theme = params.theme; 
        }
         
          
        if(params.ssoToken === null){
            // const userData = {
            //     uid: uid,
            //     ssoToken: ssoToken,			
            // };
            // this.props.loginUser1(userData);
            if (!this.props.auth.isAuthenticated) {                
                window.location = callBackBaseUrl+"?callBack="+window.location;
            }
        } 
        if (this.props.auth.isAuthenticated) {
            
        }else{
            const userData = {
                uid: uid,
                ssoToken: ssoToken,	
                source:source,
                theme:theme,	
            };
            this.props.loginUser1(userData);
        }
    };
    onChange = e => {
        this.setState({
            errors: {
            
            }
        });
        this.setState({ [e.target.id]: e.target.value });

    };
    hideShowModal(){ 
        $("#loginmodal").removeClass("show");
    }
        handleOnBlurEmail(event) {       
        this.setState({
            errors: {
                   email1:""                   
            }
         });
        }
      handleOnBlurPassword(event) {
        this.setState({
              errors: {
                password1:""
            },
         });
      }
    onSubmit = e => {
        toast.dismiss();
        e.preventDefault();
        const userData = {
            email: this.state.email,
            password: this.state.password,
			ip : this.state.ip,
			deviceName:this.state.device,
			browserName:browserName,
			osName:osName
		};
        this.props.loginUser(userData);
        
    };
    eyeFucntion= e =>{
       if(this.state.type=="password"){
        this.setState({type:"text"});
       }else{
        this.setState({type:"password"});
       }
    }
   
    
    render() {
        const { errors } = this.state;
        return (
        <>
            <div className=" tab-pane active pt-3" id="SignIn">
            {/* <form noValidate onSubmit={this.onSubmit} >
        <div className="form-group">
    <input onChange={this.onChange}  placeholder="Email" onBlur={this.handleOnBlurEmail.bind(this)} value={this.state.email} error={errors.email} id="email"
    type="email" className={classnames("form-control", { invalid: errors.email1 })} />
   <span className="text-danger">{errors.email1}</span>
                               
   </div>
  
   <div className="form-group position-relative">
   <input onChange={this.onChange} value={this.state.password}
                                    error={errors.password}
                                    id="password"
                                    type={this.state.type=='password'?"password":"text"}
                                    placeholder="Password"
                                    onBlur={this.handleOnBlurPassword.bind(this)}
                                    className={classnames("form-control", {
                                        invalid: errors.password1
                                    })}
                                    
                                />
                                <i className= {this.state.type=='password'?"las la-low-vision eyestyle":"las la-eye eyestyle"} onClick={this.eyeFucntion} ></i>
   <span className="text-danger">{errors.password1}</span>
                   
   
   </div>


   <div className="form-group ">
    <a href="#" className="" data-target="#pwdModal" data-toggle="modal" onClick={() => this.hideShowModal()}>Forgot Password</a>

  </div> 
  <div className="form-group">
    <button className="btn w100 btn_man">Log in</button>
  </div> 
  </form> */}
          
  </div>
         </>
        );
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    loginUser1: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});
export default connect(
    mapStateToProps,
    { loginUser,loginUser1 }
)(withRouter(Login));
